import { render, staticRenderFns } from "./LLFileModalImage.vue?vue&type=template&id=624d42a0&scoped=true"
import script from "./LLFileModalImage.vue?vue&type=script&lang=js"
export * from "./LLFileModalImage.vue?vue&type=script&lang=js"
import style0 from "./LLFileModalImage.vue?vue&type=style&index=0&id=624d42a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d42a0",
  null
  
)

export default component.exports